/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import baseLayerStyles from '@salesforce/retail-react-app/app/theme/foundations/layerStyles';

export default {
  ...baseLayerStyles,


  page: {
    ...baseLayerStyles.page,

    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 'container.xxxl',
    paddingBottom: 32,
    paddingTop: [0, 0, 0, 6, 8],
    paddingX: [0, 0, 0, 6, 8],
    width: '100%',
  },

  fullWidth: {
    maxWidth: '100%',
    padding: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    width: '100%',
  },
};
